import { AnyAction, Dispatch } from 'redux';
import { checkMinRequiredCards } from './checkMinRequiredCards';
import { getChartData } from './getChartDataFunction';
import { AlertColor } from '@mui/material/Alert';
import {
  resetExtraMeasureField,
  storeErrorDetails,
  storeServerData,
  updateChartData,
  updateFormatOption,
} from '../../../redux/ChartPoperties/ChartControlsActions';
import { updateChartDataForDm } from '../../../redux/DynamicMeasures/DynamicMeasuresActions';
import { sortChartData } from './sortChartData';
import { filterShowHideData } from '../../ChartOptions/ShowHide/filterShowHideData';

/**
 * Service call is made when screen is not from Dashboard. This function is called in useChartData.tsx custom hook.
 * This function decides to call api if any axes change or any filter is added.
 */
export const makeServiceCall = async (
  chartProp: any,
  chartControls: any,
  chartGroup: any,
  dashBoardGroup: any,
  tabTileProps: any,
  chartProperties: any,
  _propKey: string,
  dispatch: Dispatch<AnyAction>,
  setSeverity: React.Dispatch<React.SetStateAction<AlertColor>>,
  setOpenAlert: React.Dispatch<React.SetStateAction<boolean>>,
  setTestMessage: React.Dispatch<React.SetStateAction<string>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  screenFrom: string,
  token: any,
  savedCalculations: any,
  setShowSnackBar?: React.Dispatch<React.SetStateAction<boolean>>,
  setMessage?: React.Dispatch<React.SetStateAction<string>>,
  tooltipFormats?: any,
) => {
  const axesValues1: any = JSON.parse(JSON.stringify(chartProp.chartAxes));

  let serverCall = false;

  const modifiedBy:
    | 'filter'
    | 'filter_override_open'
    | 'filter_override_close'
    | 'axis'
    | 'filter_group'
    | null = chartProp.modified;
  const lastModifiedFilter: string | null = chartProp.lastModifiedFilter;
  if (modifiedBy === 'filter') {
    const filter_axis = chartProp.chartAxes[0];
    if (filter_axis) {
      const parts = (lastModifiedFilter ?? '').split('_');
      const isTilldateModified = parts.at(1);
      const filterId = parts.at(0);
      const filter = filter_axis.fields.find((_filter: any) => _filter.uId === filterId);
      if (filter) {
        // filter.userSele
        /**ignore relative condition as it will be always valid */
        const is_parameterized = filter.parameterId;
        const filter_type:
          | 'Search Condition'
          | 'Pick List'
          | 'Relative Filter'
          | 'Aggregate Condition'
          | 'Top N' = filter.fieldtypeoption;
        if (filter.callAPI === true || !!is_parameterized) {
          /** DO nothing   lets proceed with normal API call flow with out custom validation check*/
        } else {
          if (!filter_type) return;
          let selection = null;
          if (is_parameterized) {
          } else {
            selection = ['Search Condition', 'Aggregate Condition', 'Top N'].includes(filter_type)
              ? filter.exprInput
              : filter.userSelection;
          }
          if (
            ['Search Condition', 'Aggregate Condition',].includes(filter_type) &&
            [undefined, null, ''].includes(selection)
          )
            return;
          else if (
            filter_type === 'Pick List' &&
            (!selection || selection.length === 0) &&
            !isTilldateModified
          )
            return;
          else if (filter_type === 'Relative Filter') {
            if (
              !filter.expTypeFromdate ||
              !filter.expTypeTodate ||
              !filter.expTypeFromRelativeDate ||
              !filter.expTypeToRelativeDate ||
              !filter.exprInputToValueType ||
              !filter.exprInputFromValueType
            )
              return;
            else if (
              filter.expTypeAnchorDate !== 'today' &&
              !new Date(filter.exprInputSpecificDate)
            )
              return;
          }
        }
      } else return;
    }
  } else if (modifiedBy === 'filter_group') {
    const parts = (lastModifiedFilter ?? '').split('_');
    /**
     *  combine all except last
     * as filter group id format is "<ds_id>_Filter Group <milisecond_value_at_time_ofcreattion"
     */
    const grpId = parts.slice(0, 2).join('_');
    const filterId = parts.at(2) ?? '';
    const isTillDateModified = parts.at(3);
    if (!grpId || !filterId) return;
    const group = chartGroup.groups[grpId];
    if (!group) return;
    const filter = group.filters.find((_filter: any) => _filter.uId === filterId);
    if (filter) {
      // filter.userSele
      /**ignore relative condition as it will be always valid */
      const filter_type: 'Search Condition' | 'Pick List' | 'Aggregate Condition' | 'Top N' =
        filter.fieldtypeoption;
      if (filter.callAPI === true) {
        /** DO nothing   lets proceed with normal API call flow with out custom validation check*/
      } else {
        if (!filter_type) return;
        if (filter.isSingleSelection && (!filter.userSelection || !filter.userSelection[0])) return;
        if (
          ['Search Condition', 'Aggregate Condition', 'Top N'].includes(filter_type) &&
          [undefined, null, ''].includes(filter.exprInput)
        )
          return;
        else if (
          filter_type === 'Pick List' &&
          (!filter.userSelection || filter.userSelection.length === 0) &&
          !isTillDateModified
        )
          return;
      }
    } else return;
  } else if (modifiedBy === 'filter_override_open') return;
  if (
    chartProp.axesEdited ||
    chartGroup.chartFilterGroupEdited ||
    dashBoardGroup.dashBoardGroupEdited ||
    tabTileProps.isDashboardTileSwitched ||
    chartControls.properties[_propKey].callQueryAPI ||
    chartControls.properties[_propKey].chartData.length === 0
  ) {
    //add reuse key in dynamic measure state

    if (chartProp.reUseData) {
      serverCall = false;
    } else {
      var minReq = checkMinRequiredCards(chartProp, chartProperties.properties[_propKey].chartType);

      if (minReq) {
        serverCall = true;
        dispatch(storeServerData(_propKey, ''));
      } else {
        if (chartProperties.properties[_propKey].chartType === 'richText') {
          dispatch(updateChartDataForDm(''));
        } else {
          dispatch(updateChartData(_propKey, ''));
        }
      }
    }
  }

  // if (chartProp.chartType === 'scatterPlot') {
  //   var combinedValuesForMeasure = { name: 'Measure', fields: [] };
  //   var values1 = axesValues1[2].fields;
  //   var values2 = axesValues1[3].fields;
  //   var allValues = values1.concat(values2);
  //   combinedValuesForMeasure.fields = allValues;
  //   axesValues1.splice(2, 2, combinedValuesForMeasure);
  // }

  // if (
  //   chartProp.chartType === 'heatmap' ||
  //   chartProp.chartType === 'crossTab' ||
  //   chartProp.chartType === 'boxPlot' ||
  //   chartProp.chartType === 'bubbleMap'
  // ) {
  //   var combinedValuesForDimension = { name: 'Dimension', fields: [] };
  //   var values1 = axesValues1[1].fields;
  //   var values2 = axesValues1[2].fields;

  //   var allValues = values1.concat(values2);
  //   combinedValuesForDimension.fields = allValues;
  //   axesValues1.splice(1, 2, combinedValuesForDimension);
  // }

  // if (chartProp.chartType === 'table') {
  //   var combinedValuesForDimension = { name: 'Dimension', fields: [] };

  //   combinedValuesForDimension.fields = axesValues1[1].fields;

  //   if (axesValues1.length === 4) {
  //     axesValues1.splice(1, 2, combinedValuesForDimension);
  //   } else if (axesValues1.length === 3) {
  //     axesValues1.splice(1, 1, combinedValuesForDimension);
  //   }
  // }

  const showErrorNotification = (type: AlertColor, message: string) => {
    setSeverity(type);
    setOpenAlert(true);
    setTestMessage(message);

    if (
      message ===
      'The selected dataset does not contain all the fields used in this chart. Please remove or replace the missing fields and try again.'
    ) {
      return;
    }
    setTimeout(() => {
      setOpenAlert(false);
      setTestMessage('');
    }, 2000);
  };

  const chartErrorDetails = (propKey: string, error: any) => {
    dispatch(storeErrorDetails(propKey, error));
  };

  const removeExtraMeasureField = (propKey: string) => {
    dispatch(resetExtraMeasureField(propKey));
  };
  
  let serverData = [];

  //call api when there are extra measure fields or when the extra field is last so that response can be updated as well as for minReq(checking if the number of fields are enough to show the data).
  if (tooltipFormats?.extraMeasureField[0].fields.length > 0 || tooltipFormats?.isLastField) {
    const minReq = checkMinRequiredCards(chartProp, chartProperties.properties[_propKey].chartType);
    if (minReq) {
      serverCall = true;
    }
  }

  if (serverCall || (chartProp.chartType === 'crossTab' && chartProp.axesEdited)) {
    setLoading(true);
    serverData = await getChartData(
      axesValues1,
      chartProp,
      chartControls,
      chartGroup,
      tabTileProps.tablesForSelectedDataSets,
      dashBoardGroup,
      _propKey,
      screenFrom,
      token,
      chartProperties.properties[_propKey].chartType,
      setShowSnackBar,
      setMessage,
      undefined,
      savedCalculations,
      showErrorNotification,
      chartErrorDetails,
      tooltipFormats,
      removeExtraMeasureField,
    );

    // Dispatch action to store server data
    dispatch(storeServerData(_propKey, serverData));

    //for tooltip - get response & sort extra measure & then save in redux.
    //-------- extraMeasureFieldsResponses includes chartData including extra field data.---------//
    const tooltipExtraMeasureField = tooltipFormats?.extraMeasureField;
    if (serverData && tooltipFormats && tooltipExtraMeasureField) {
      let extraMeasureResponse: any[] = [];
      if (tooltipExtraMeasureField[0]?.fields.length > 0) {
        extraMeasureResponse = sortChartData(
          serverData,
          chartProp,
          chartControls,
          _propKey,
          tooltipFormats,
        );
      }
      //add dispatch for tooltip
      dispatch(
        updateFormatOption(
          _propKey,
          'tooltipFormats',
          'extraMeasureFieldsResponses',
          JSON.parse(JSON.stringify(extraMeasureResponse)),
        ),
      );
    }

    if (chartProperties.properties[_propKey].chartType === 'richText') {
      dispatch(updateChartDataForDm(sortChartData(serverData, chartProp, chartControls, _propKey)));
    } else {
      dispatch(
        updateChartData(_propKey, sortChartData(serverData, chartProp, chartControls, _propKey)),
      );
    }
    if (
      typeof chartControls.properties[_propKey].showHide?.numberInput === 'number' &&
      serverData
    ) {
      const showHide = chartControls.properties[_propKey].showHide;
      filterShowHideData(
        showHide.operator,
        dispatch,
        serverData,
        _propKey,
        showHide.numberInput,
        chartControls,
        chartProperties,
      );
    }
    setLoading(false);
  }
  return;
};
